import React from 'react';
import StudentAttendanceView from '../../components/Attendance/StudentAttendanceView';

export default function AdmissionStudentAttendance() {
  return (
    <StudentAttendanceView
      mode="ops"
      title="Student attendance"
      subtitle="View attendance across all teachers and students"
    />
  );
}
